import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { makeStyles } from '@material-ui/core'
import DayCell from './DayCell'
import { buildMonthCells, DAY_KEY_FORMAT } from './utils'

const useStyles = makeStyles({
  weekdays: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: 6,
    marginBottom: 6,
  },
  weekday: {
    textAlign: 'center',
    fontSize: 13,
    fontWeight: 500,
    color: '#686868',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: 6,
  },
})

const WEEKDAY_LABELS = [0, 1, 2, 3, 4, 5, 6].map((i) => dayjs().day(i).format('ddd'))

const CalendarGrid = ({ month, buckets, onEventClick, mobile, selectedKey, onSelectDay }) => {
  const styles = useStyles()
  const monthIndex = dayjs(`${month}-01`).month()
  const today = dayjs()
  const cells = buildMonthCells(month)

  return (
    <div>
      <div className={styles.weekdays}>
        {WEEKDAY_LABELS.map((label) => (
          <span key={label} className={styles.weekday}>
            {label}
          </span>
        ))}
      </div>
      <div className={styles.grid}>
        {cells.map((day) => {
          const key = day.format(DAY_KEY_FORMAT)
          return (
            <div key={key} data-testid="day-cell">
              <DayCell
                day={day}
                inMonth={day.month() === monthIndex}
                isToday={day.isSame(today, 'day')}
                events={buckets[key] || []}
                onEventClick={onEventClick}
                mobile={mobile}
                selected={selectedKey === key}
                onSelectDay={onSelectDay}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

CalendarGrid.propTypes = {
  month: PropTypes.string.isRequired,
  buckets: PropTypes.object.isRequired,
  onEventClick: PropTypes.func,
  mobile: PropTypes.bool,
  selectedKey: PropTypes.string,
  onSelectDay: PropTypes.func,
}

CalendarGrid.defaultProps = {
  onEventClick: undefined,
  mobile: false,
  selectedKey: null,
  onSelectDay: undefined,
}

export default CalendarGrid
